<div class="relative h-full">
  <div class="blink absolute h-full w-1 rounded-full bg-white"></div>
</div>
